import { TutorialStep } from 'src/replicant/tutorial/tutorial.ruleset';
import { TutorialEvent } from '../TutorialController';
import OrdinaryTutorial from './OrdinaryTutorial';
import { startVisitSequence } from 'src/game/visit/visit.sequence';
import { user } from 'src/StateObserver';
import { isPlatformGuest } from 'src/lib/utils';
import { GCInstant as platform } from 'src/lib/gcinstant';
import * as Visit from 'src/replicant/visit';
import { ActionSequence } from 'src/lib/ActionSequence';
import * as Tutorial from 'src/replicant/tutorial';
import { showTutorial } from '../tutorial.util';

export class VisitFriendTutorial extends OrdinaryTutorial {
  public readonly step: TutorialStep = 'visitFriend';

  public async handleEvent(event: TutorialEvent): Promise<boolean> {
    if (
      // On game start.
      event === 'gameStarted' &&
      // And if the visit friend tutorial is pending.
      isVisitFriendTutorialPending()
    ) {
      await ActionSequence.start(
        [() => this.handleVisitFriendUnlocked()],
        'PostLaunch',
      );
      return false;
    }

    if (
      // On pet level increase.
      event === 'levelIncreased' &&
      // And if the visit friend tutorial is pending.
      isVisitFriendTutorialPending()
    ) {
      return this.handleVisitFriendUnlocked();
    }

    if (event !== 'visitPopupOpened') return false;

    await showTutorial('visitFriend', {
      $stepIndex: 10,
      $stepName: 'visitFriend_start',
    });

    return true;
  }

  private async handleVisitFriendUnlocked() {
    // Trigger the visit sequence instead of the tutorial directly,
    // which will, in turn, trigger the tutorial alongside the rest of the visit flow.
    await startVisitSequence({ selectedTab: 'friends' }, undefined);

    return false;
  }
}

/**
 * Return true if visit friend feature is unlocked and tutorial has not been shown yet.
 */
function isVisitFriendTutorialPending(): boolean {
  const isUnlocked = isPlatformGuest(platform)
    ? Visit.getters.hasMetUnlockCriteria(user())
    : Visit.getters.isUnlocked(user());

  return (
    isUnlocked &&
    !Tutorial.getters.isTutorialStepComplete(user(), 'visitFriend')
  );
}
